module.exports = __webpack_public_path__ + "media/fireworks.2aed4abc.mp3";